<template>
    <div class="pageWarp">
        <!-- 标题 -->
        <Title-Box :top-title="topTitle"></Title-Box>

<!--        &lt;!&ndash; 黄色提示栏 &ndash;&gt;-->
<!--        <div :class="{'hide': hideTopYellowTips}" class="yellow_tips_box boxs flex_h_hL_vC">-->
<!--            <span class="info">为约束用户活动参与的真实行为，在用户办理优享合约的同时需用户缴纳一定的冻结金作为合约保证资金，存于用户的建行账户或二类账户中。用户每正常缴纳1个月月租，则为用户解冻其中一部分资金。</span>-->
<!--            <img @click="hideTopYellowTips = true" class="icon_close_yellow" -->
<!--                 src="@/assets/images/enjoy/yellowCloseIcon.png" alt="">-->
<!--        </div>-->
<!--        -->
        <!-- 筛选框 -->
        <sr-filter class="searchBox" @search="handleSearch" @reset="handleReset">
            <template slot="otherCom">

                <el-form-item>
                    <el-date-picker
                            v-model="timeRange"
                            type="daterange"
                            unlink-panels
                            size="medium"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            :default-time="['00:00:00', '23:59:59']"
                            value-format="yyyyMMdd"
                            :picker-options="timePickerOptions"
                    >
                    </el-date-picker>
                </el-form-item>

                <el-form-item>
                    <el-input
                            v-model="searchForm.params.orderId"
                            placeholder="请输入订单号"
                            @keyup.enter.native="handleSearch"
                            maxlength="25" size="medium" clearable
                    >
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-input
                            v-model="searchForm.params.userName"
                            placeholder="请输入用户姓名"
                            @keyup.enter.native="handleSearch"
                            maxlength="25" size="medium" clearable
                    >
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-input
                            v-model="searchForm.params.userCode"
                            placeholder="请输入冻结金用户编号"
                            @keyup.enter.native="handleSearch"
                            maxlength="25" size="medium" clearable
                    >
                    </el-input>
                </el-form-item>

<!--                <el-form-item>-->
<!--                    <el-input-->
<!--                            v-model="searchForm.params.phone"-->
<!--                            placeholder="请输入开户号码"-->
<!--                            @keyup.enter.native="handleSearch"-->
<!--                            maxlength="25" size="medium" clearable-->
<!--                    >-->
<!--                    </el-input>-->
<!--                </el-form-item>-->



<!--                <el-form-item>-->
<!--                    <el-input-->
<!--                            v-model="searchForm.params.idCardNum"-->
<!--                            placeholder="请输入身份证号码"-->
<!--                            @keyup.enter.native="handleSearch"-->
<!--                            maxlength="25" size="medium" clearable-->
<!--                    >-->
<!--                    </el-input>-->
<!--                </el-form-item>-->

<!--                <el-form-item>-->
<!--                    <el-input-->
<!--                            v-model="searchForm.keep_contract_periodsName"-->
<!--                            placeholder="请输入套餐名称"-->
<!--                            @keyup.enter.native="handleSearch"-->
<!--                            maxlength="30" size="medium" clearable-->
<!--                    >-->
<!--                    </el-input>-->
<!--                </el-form-item>-->

<!--                <el-form-item>-->
<!--                    <el-input-->
<!--                            v-model="searchForm.modelName"-->
<!--                            placeholder="请输入机型名称"-->
<!--                            @keyup.enter.native="handleSearch"-->
<!--                            maxlength="25" size="medium" clearable-->
<!--                    >-->
<!--                    </el-input>-->
<!--                </el-form-item>-->

                <!-- <el-form-item>
                    <el-select v-model="searchForm.status" 
                                @change="handleSearch" 
                                placeholder="选择订单状态" 
                                size="medium" clearable
                                filterable>
                        <el-option 
                            v-for="item in statusOptions" 
                            :key="item.key" 
                            :label="item.label" 
                            :value="item.key"
                        >
                        </el-option>
                    </el-select>
                </el-form-item> -->

            </template>
        </sr-filter>

        <div class="summary_area boxs flex_h">
            <!-- 左边统计 -->
            <div class="left_block summary_block boxs flex_h_hL_vC">
                <div class="first_box boxs flex_h ite-c">
                    <span class="clamp_1">共查询到 {{countType.sumCount}} 笔</span>
                </div>
                <div class="other_box boxs flex_v_hC_vC">
                    <span class="topText clamp_1">有效 (笔)</span>
                    <span class="botText clamp_1">{{countType.validStatusSumCount}}</span>
                </div>
                <div class="other_box boxs flex_v_hC_vC">
                    <span class="topText clamp_1">失效 (笔)</span>
                    <span class="botText clamp_1">{{countType.inValidStatusSumCount}}</span>
                </div>
            </div>
            
            <div  class="summary_block boxs flex_v_hL_vC">
                <div class="first_text flex_h_hS_vC">
                    <span>原始冻结金额</span>
                    <span><small>{{contractAt.sumCount}}</small>笔</span>
                </div>
                <div class="second_text clamp_1 flex_h ite-fe">
                    <span class="bigT">{{contractAt.sum_contract_at| centsToYuan}}</span> 元
                </div>
            </div>
            
            <div  class="summary_block boxs flex_v_hL_vC">
                <div class="first_text flex_h_hS_vC">
                    <span>剩余冻结金</span>
                    <span><small>{{freezeAt.sumCount}}</small>笔</span>
                </div>
                <div class="second_text clamp_1 flex_h ite-fe">
                    <span class="bigT">{{freezeAt.sumFreezeAt| centsToYuan}}</span> 元
                </div>
            </div>

            <div class="summary_block boxs flex_v_hL_vC">
                <div class="first_text flex_h_hS_vC">
                    <span>解冻金</span>
                    <span><small>{{unfreezeAt.sumCount}}</small>笔</span>
                </div>
                <div class="second_text clamp_1 flex_h ite-fe">
                    <span class="bigT">{{unfreezeAt.sum_has_unfreeze_at| centsToYuan}}</span> 元
                </div>
            </div>

            <div class="summary_block boxs flex_v_hL_vC">
                <div class="first_text flex_h_hS_vC">
                    <span>滞纳金</span>
                    <span><small>{{lateAt.sumCount}}</small>笔</span>
                </div>
                <div class="second_text clamp_1 flex_h ite-fe">
                    <span class="bigT">{{lateAt.sum_late_at| centsToYuan}}</span> 元
                </div>
            </div>
            
            <div class="summary_block boxs flex_v_hL_vC">
                <div class="first_text flex_h_hS_vC">
                    <span>违约金</span>
                    <span><small>{{breakAt.sumCount}}</small>笔</span>
                </div>
                <div class="second_text clamp_1 flex_h ite-fe">
                    <span class="bigT">{{breakAt.sum_break_at| centsToYuan}}</span> 元
                </div>
            </div>
        </div>



        <!-- 表格 -->
        <div class="botTable boxs tableTheadGray">
            <div class="tableTop">
                <span class="top_le">冻结金列表</span>

<!--                <button class="butStyle pinkBtn exportBtn" @click="tableExport">-->
<!--                    <i class="exportIcon"></i>-->
<!--                    <span>导出</span>-->
<!--                </button>-->
            </div>
            <el-table :data="tableData"
                        style="width: 100%;"
                        border
                        fit
                        highlight-current-row
                        tooltip-effect="dark"
            >
                <el-table-column label="冻结合约单号" prop="id" min-width="200" header-align="center" align="center"
                                show-overflow-tooltip></el-table-column>
                <el-table-column label="累计履约期数" prop="keep_contract_periods" width="120" header-align="center" align="center"
                                show-overflow-tooltip></el-table-column>
                <el-table-column label="用户" prop="user_name" width="70" header-align="center" align="center"
                                show-overflow-tooltip></el-table-column>
                <el-table-column label="剩余冻结金额（元）" prop="residue_unfreeze_fee" width="150" header-align="center" align="right"
                                show-overflow-tooltip>
                    <template slot-scope="scope" class="orangeText">
                      <span class="orangeText">
                              {{scope.row.residue_unfreeze_fee | centsToYuan}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="原始冻结金额(元)" prop="contract_at" width="150" header-align="center" align="right"
                                show-overflow-tooltip>
                    <template slot-scope="scope" class="orangeText">
                      <span class="orangeText">
                              {{scope.row.contract_at | centsToYuan}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="每期解冻金额(元)" prop="unfreeze_month_money" width="150" header-align="center" align="right"
                                show-overflow-tooltip>
                    <template slot-scope="scope" class="orangeText">
                      <span class="orangeText">
                              {{scope.row.unfreeze_month_money | centsToYuan}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="已解冻期" prop="has_unfreeze_periods" width="120" header-align="center" align="center"
                                show-overflow-tooltip></el-table-column>
                <el-table-column label="已解冻(元)" prop="has_unfreeze_at" width="120" header-align="center" align="center"
                                show-overflow-tooltip>
                    <template slot-scope="scope" class="orangeText">
                      <span class="orangeText">
                              {{scope.row.has_unfreeze_at | centsToYuan}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="已扣款(元)" prop="has_withhold" width="120" header-align="center" align="center"
                                show-overflow-tooltip>
                    <template slot-scope="scope" class="orangeText">
                      <span class="orangeText">
                              {{scope.row.has_withhold | centsToYuan}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="有效期至" prop="expire_date" min-width="120" header-align="center" align="center"
                                show-overflow-tooltip></el-table-column>
                <el-table-column label="关联订单号" prop="order_id" min-width="180" header-align="center" align="center"
                                show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" fixed="right" min-width="78" header-align="center" align="center"
                                show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-button @click="goDetailPage(scope)"
                                    class="greenT"
                                    icon="el-icon-search"
                                    type="text"
                                    title="详情">详情
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pageBox boxs">
                <el-pagination @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :current-page="searchForm.current"
                               :page-sizes="[10, 20, 30]"
                               :page-size="searchForm.size"
                               layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>

    </div>
</template>

<script>
    import TitleBox from '@/components/Common/TitleBox/TitleBox.1';
    import SrFilter from '@/components/Common/Filter/Filter';
    import {formatDate} from '@/utils/dateFormatter';
    import {objectToQueryString} from '@/utils/commonUtils.js';
    import {
        freezeFeeTypeGroupNums,
        freezeFeelist,
    } from '@/api/Tbs/FrozenFeeManage/frozenFeeManage.js'

    // 搜索表格的条件-筛选栏
    const defaultSearchForm = {
        params: {
            // 其他请求参数
            orderId: null, //订单号
            userCode: null, //用户id
            userName: null, //用户姓名
            statusList: [], //订单状态
        },
        current: 1,
        size: 10
    }
    export default {
        data() {
            return {
                //标题
                topTitle: {
                    title: '冻结金管理',
                    subTit: ''
                },

                // 是否隐藏页面顶部提示信息
                hideTopYellowTips: false, 

                timeRange: null,

                countType: {sumCount: "1", validStatusSumCount: "1", inValidStatusSumCount: "0"},
                // 表格搜索条件
                searchForm: this.initSearchParams(),
                // 全部状态
                statusOptions: [
                    {key: 1, label: '待冻结'},
                    {key: 2, label: '待竣工'},
                    {key: 3, label: '已竣工'},
                    {key: 4, label: '已关闭'},
                ],
                breakAt: {sumCount: 0, sum_break_at: 0},
                unfreezeAt: {sumCount: 0, sum_has_unfreeze_at: 0},
                freezeAt: {sumCount: 1, sumFreezeAt: 4000},
                lateAt: {sumCount: 0, sum_late_at: 0},
                contractAt: {sumCount: 1, sum_contract_at: 4000},

                // 表格数据
                tableData: [],
                // 表格数据总数
                total: 0,
                // 日期时间选择器
                timePickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                    shortcuts: [
                        {
                            text: '今天',
                            onClick(picker) {
                                picker.$emit('pick', [new Date(), new Date()])
                            }
                        },
                        {
                            text: '昨天',
                            onClick(picker) {
                                const end = new Date()
                                const start = new Date()
                                start.setTime(start.getTime() - 3600 * 1000 * 24)
                                picker.$emit('pick', [start, end])
                            }
                        },
                        {
                            text: '最近三天',
                            onClick(picker) {
                                const end = new Date()
                                const start = new Date()
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
                                picker.$emit('pick', [start, end])
                            }
                        },
                        {
                            text: '最近一周',
                            onClick(picker) {
                                const end = new Date()
                                const start = new Date()
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                                picker.$emit('pick', [start, end])
                            }
                        },
                        {
                            text: '最近一个月',
                            onClick(picker) {
                                const end = new Date()
                                const start = new Date()
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                                picker.$emit('pick', [start, end])
                            }
                        },
                        {
                            text: '最近三个月',
                            onClick(picker) {
                                const end = new Date()
                                const start = new Date()
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                                picker.$emit('pick', [start, end]);
                            }
                        }
                    ]
                }
            }
        },
        computed: {
            // 开始时间
            min_accept_time() {
                return this.timeRange ? this.timeRange[0] : null
            },
            // 结束时间
            max_accept_time() {
                return this.timeRange ? this.timeRange[1] : null
            }
        },
        components: {
            TitleBox,
            SrFilter,
        },
        created() {
            this.getDataList()
        },
        methods: {
            tableExport() {
                this.searchForm.params.beginTime = this.min_accept_time
                this.searchForm.params.endTime = this.max_accept_time
                // var url = `${this.$baseUrl}/!Busi/Financial/Withdraw/~query/Q_WITHDRAW.Q_REVIEW_DETAILS?_exeresult=excel&${objectToQueryString(this.searchForm)}`;
                // console.log(url)
                // window.open(url, '_blank');
            },
            formatDefault: function (date) {
                return formatDate(date, 'yyyy年MM月');
            },

            // 点击切换订单状态
            changeStatueEvent(msg){
                this.searchForm.status = msg;
                this.getDataList();
            },
            // 获取表格数据
            async getDataList() {
                try {
                    this.searchForm.params.beginTime = this.min_accept_time
                    this.searchForm.params.endTime = this.max_accept_time
                    console.log(this.searchForm)
                    const result = await freezeFeelist(this.searchForm);
                    console.log(result)
                    this.tableData = result.data.records
                    this.total = result.data.total
                    console.log(this.tableData)

                    this.freezeFeeTypeGroupNums();
                } catch (e) {
                    this.$message.error('接口请求失败:' + e.msg);
                }
            },

            // 查询冻结金分类数量
            async freezeFeeTypeGroupNums() {
                try {
                    const result = await freezeFeeTypeGroupNums(this.searchForm.params);
                    console.log(result)
                    this.contractAt = result.data.contractAt;
                    this.lateAt = result.data.lateAt;
                    this.freezeAt = result.data.freezeAt;
                    this.breakAt = result.data.breakAt;
                    this.unfreezeAt = result.data.unfreezeAt;
                    this.countType = result.data.countType;

                } catch (e) {
                    this.$message.error('接口请求失败:' + e.msg);
                }
            },

            // 列表过滤查询
            handleSearch() {
                this.getDataList()
            },
          initSearchParams() {
            return this.$deepClone(defaultSearchForm);
          },
            // 搜索重置（清空）
            handleReset() {
                // 初始化参数
              this.searchForm = this.initSearchParams()
                this.timeRange = null;
                // 获取表格数据
                this.getDataList()
            },
            // 列表每页条数变了
            handleSizeChange(val) {
                this.searchForm.size = val
                this.getDataList()
            },
            // 列表当前页码变了
            handleCurrentChange(val) {
                this.searchForm.current = val
                this.getDataList()
            },
            
            // 跳转到详情页
            goDetailPage(scope) {
                this.$router.push({
                    // path: '/tbs/fundManage/reducedFee',
                    path: '/tbs/fundManage/frozenFeeDetail',
                    query: {
                        id: scope.row.id
                    }
                })
            },

        }
    }
</script>

<style lang="scss" scoped>
    .greenT {
        color: #2DBAA5 !important;
    }
    .lightGT {
        color: #76C819 !important;
    }
    .orangeT {
        color: #FA6241 !important;
    }
    .grayT {
        color: #B7B2AF !important;
    }


    .pageWarp {
        height: calc(100vh - 88px);
    }

    // 黄色提示栏
    .pageWarp .yellow_tips_box {
        margin-top: 0px;
        width: 100%;
        min-height: 28px;
        padding: 6px 9px 6px 12px;
        background: #FFFAEB;
        border: 1px solid #FFC400;
        transition: all 0.3s ease;
    }
    .pageWarp .yellow_tips_box.hide {
        display: none;
        transition: all 0.3s ease;
    }
    .yellow_tips_box .info {
        width: calc( 100% - 9.71px - 5px );
        line-height: 16px;
        color: #FFC400;
        font-size: 12px;
        margin-right: 5px;
    }
    .yellow_tips_box .icon_close_yellow {
        width: 9.71px;
        height: 9.71px;
    }


    // 筛选框
    .pageWarp .searchBox {
        margin-top: 0px;
    }


    // 总结
    .pageWarp .summary_area {
        flex-wrap: wrap;
    }
    .pageWarp .summary_block {
        margin-top: 12px;
        width: 207px;
        height: 72px;
        background: #fff;
        // border-radius: 5px;
        box-sizing: border-box;
        padding: 12px 20px;
        font-size: 12px;
        color: #333333;
        white-space: nowrap;
        margin-right: 14px;
    }
    .pageWarp .summary_block .first_text{
        min-width: 160px;
        max-width: 100%;
        margin-bottom: 6px;
    }
    .pageWarp .summary_block .first_text small{
        color: #2DBAA5;
        margin-right: 3px;
    }
    .pageWarp .summary_block .second_text{
        // line-height: 16px;
        height: 20px;
    }
    .pageWarp .summary_block .second_text span.bigT{
        height: 20px;
        color: #FA6241;
        font-size: 20px;
        font-weight: normal;
        margin-right: 3px;
    }

    // 左边统计
    .pageWarp .summary_area .summary_block.left_block {
        width: 389px;
        height: 72px;
        background: #fff;
        border-radius: 5px;
        box-sizing: border-box;
        padding: 12px 0px;
        font-size: 12px;
        color: #333333;
        white-space: nowrap;
        margin-right: 14px;
    }
    .summary_area .left_block .first_box {
        width: calc( 389px - 129px - 129px );
        height: 100%;
        padding: 0 0 0 10px;
        box-sizing: border-box;
    }
    .summary_area .left_block .first_box span {
        width: 100%;
        text-align: center;
    }
    .summary_area .left_block .other_box {
        width: 129px;
        height: 100%;
        border-left: 1px solid #F8F8F8;
        padding: 0 16px 0 0;
    }
    .summary_area .left_block .other_box .topText {
        width: 100%;
        text-align: center;
        color: #7F7F7F;
    }
    .summary_area .left_block .other_box .botText {
        width: 100%;
        text-align: center;
        font-size: 20px;
        margin-top: 6px;
    }

    


    // 表格
    .pageWarp .botTable {
        margin-top: 12px;
        width: 100%;
        // max-height: 408px;
    }

    .botTable .tableTop {
        height: 54px;
        padding: 0 12px;
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        align-items: center;
        background-color: #ffffff;
        border: 1px solid #EEEEEE;
        border-bottom: none;
    }

    .botTable .tableTop .top_le {
        font-size: 15px;
        font-weight: bold;
        color: #4E4A46;
    }

    .botTable .tableTop .exportBtn {
        width: 72px;
        height: 30px;
        line-height: 30px;
        font-size: 13px;
        border-radius: 4px;
        &:hover {
        background-color: rgb(247, 143, 120);
        }
    }

    .botTable .tableTop .exportBtn .exportIcon {
        display: inline-block;
        width: 14px;
        height: 14px;
        background: url('../../../../assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportBtn.png') no-repeat;
        background-size: 14px 14px;
    }

    /* 分页条 */
    .pageBox {
        width: 100%;
        padding: 15px 0 10px;
        display: flex;
        justify-content: flex-end;
        background: #ffffff;
        border: 1px solid #E4E4E4;
        border-top: none;
        //   border-bottom-left-radius: 3px;
        //   border-bottom-right-radius: 3px;
    }

    // 弹窗按钮-取消按钮
    .cancelBtn {
        width: 120px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        border-radius: 4px;
        background: #FFFFFF;
        color: #2B2727;
        color: #666666;
        border: 1px solid #EEEEEE;
        box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        &:hover {
        // background-color: #f1f1f1;
        border: 1px solid #d1d0d0;
        }
    }

    // 弹窗按钮-橙色按钮
    .refuseOBtn {
        width: 120px;
        height: 40px;
        line-height: 40px;
        margin-left: 20px;
        font-size: 14px;
        border-radius: 4px;
        background: #FA6241;
        color: #FFFFFF;
        &:hover {
        background-color: rgb(247, 143, 120);
        }
    }

    
</style>

